import { TaxRate } from '../../../../common/models/tax-rate';

const textOf = (text?: TaxRate['invoiceText']): string =>
    JSON.stringify(
        Object.entries(text ?? {})
            .filter(([, value]) => typeof value === 'string' && '' !== value.trim())
            .sort(([a], [b]) => a.localeCompare(b))
    );

const isLocked = (taxRate: TaxRate): boolean =>
    Object.values(taxRate.description ?? {}).some(
        value => typeof value === 'string' && value.toUpperCase().includes('GESPERRT')
    );

/**
 * The accounts a sent line may move to: the same rate, BMD tax code, branch
 * and invoice text, so neither the export's tax nor the sent document
 * changes; never one the accounting marked as locked. The server checks the
 * same (#2326 R-239, GF 28.10.2026).
 */
export const interchangeableTaxRates = (current: TaxRate, taxRates: TaxRate[]): TaxRate[] =>
    taxRates.filter(
        taxRate =>
            taxRate.id === current.id ||
            (!isLocked(taxRate) &&
                (taxRate.taxPercentage ?? null) === (current.taxPercentage ?? null) &&
                (taxRate.taxCode ?? null) === (current.taxCode ?? null) &&
                (taxRate.branchNumber ?? null) === (current.branchNumber ?? null) &&
                textOf(taxRate.invoiceText) === textOf(current.invoiceText))
    );
